// No wrappers as this code needs to run as soon as the DOM is ready.
document.addEventListener("DOMContentLoaded", () => {

  // Initialize Swiper.
  // nth-child(2) checks if more then one article is present in the hero image.
  document.querySelectorAll('.hero-image:has(article:nth-child(2))').forEach((image_container) => {

    // Create next and previous buttons.
    let swiper_container = document.createElement('div');
    swiper_container.classList.add('swiper');
    image_container.insertBefore(swiper_container, image_container.firstChild);

    // Wrapper for swiper slides.
    let swiper_wrapper = document.createElement('div');
    swiper_wrapper.classList.add('swiper-wrapper');
    swiper_container.appendChild(swiper_wrapper);

    // Add swiper wrapper classes.
    image_container.querySelectorAll('article').forEach((swiper_slide) => {
      swiper_wrapper.appendChild(swiper_slide);
      swiper_slide.classList.add('swiper-slide');
    });

    // Pagination.
    let swiper_pagination = document.createElement('div');
    swiper_pagination.classList.add('swiper-pagination');
    swiper_container.appendChild(swiper_pagination);

    let seconds = 4;
    let swiper = new Swiper(swiper_container, {
      direction: 'horizontal',
      loop: true,
      autoplay: {
        delay: 1000 * seconds,
        disableOnInteraction: false,
      },

      pagination: {
        el: swiper_pagination,
        type: "progressbar",
      },
    });
  });
});
